(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
    const containers = document.querySelectorAll('[data-accelerated-checkout-text]');
    if (!containers.length) return;

    for (const container of containers) {
      const customText = container.getAttribute('data-accelerated-checkout-text');
      if (!customText) continue;

      const applyText = () => {
        const button = container.querySelector('.shopify-payment-button__button');
        if (!button) return;

        button.textContent = customText;
      };

      applyText();

      const observer = new MutationObserver(() => {
        applyText();
      });

      observer.observe(container, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tab-group"] && !Shopify.designMode) return;
  try {
    (function () {
    function syncTabLabelsFromPanels(root) {
      root.querySelectorAll('[role="tabpanel"][data-tab-label]').forEach(function (panel) {
        var label = panel.getAttribute('data-tab-label');
        if (label === null || label === '') return;
        var tabId = panel.getAttribute('aria-labelledby');
        var tab = tabId ? document.getElementById(tabId) : null;
        if (!tab) return;
        var labelEl = tab.querySelector('.tab-group__tab-label');
        if (labelEl) {
          labelEl.textContent = label;
        } else {
          tab.textContent = label;
        }
      });
    }

    function initTabGroup(root) {
      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      if (!tabs.length || !panels.length) return;

      /* Sempre sincronizar títulos a partir dos painéis (editor do tema + evita dessincronia Liquid) */
      syncTabLabelsFromPanels(root);

      if (root.getAttribute('data-tab-js-init') === 'true') return;
      root.setAttribute('data-tab-js-init', 'true');

      var firstPanel = root.querySelector('.tab-group__panel');
      if (firstPanel && !root.querySelector('.tab-group__panel.is-active')) {
        firstPanel.classList.add('is-active');
      }

      var activePanel = root.querySelector('.tab-group__panel.is-active');
      var firstTab = tabs[0];
      if (activePanel && firstTab) {
        var activeId = activePanel.getAttribute('aria-labelledby');
        tabs.forEach(function (tab) {
          var on = tab.id === activeId;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
      } else if (firstTab) {
        firstTab.classList.add('is-active');
        firstTab.setAttribute('aria-selected', 'true');
        firstTab.setAttribute('tabindex', '0');
      }

      function switchTab(selected) {
        var targetId = selected.getAttribute('aria-controls');
        tabs.forEach(function (tab) {
          var on = tab === selected;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var match = panel.id === targetId;
          panel.classList.toggle('is-active', match);
        });
      }

      function onKeydown(e) {
        var arr = Array.prototype.slice.call(tabs);
        var idx = arr.indexOf(e.currentTarget);
        var next = idx;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          next = (idx + 1) % arr.length;
          arr[next].focus();
          switchTab(arr[next]);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          next = (idx - 1 + arr.length) % arr.length;
          arr[next].focus();
          switchTab(arr[next]);
        } else if (e.key === 'Home') {
          e.preventDefault();
          arr[0].focus();
          switchTab(arr[0]);
        } else if (e.key === 'End') {
          e.preventDefault();
          arr[arr.length - 1].focus();
          switchTab(arr[arr.length - 1]);
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          switchTab(tab);
          tab.focus();
        });
        tab.addEventListener('keydown', onKeydown);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-tab-group-block]').forEach(initTabGroup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
